import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';

import ImageContainer from '../image-handler/ImageContainer';

import RectangleLine from "./StepFour/RectangleLine";
import SocketLine from "./StepThree/SocketLine";

class Step4 extends Component {

    componentDidMount() {}

    render() {
        return (
            <div className="wt-step-4 step-content">
                <div className='row'>
                    <h5 className='col s6' >
                        {this.props.translate('KRW.stepFour.menu.title')}
                    </h5>
                </div>
                <div className='col s12'>
                    <div className='row' style={{color: '#8C8D90'}}>
                        <div className='col l3 s12'>&nbsp;</div>
                        <div className='col l2 s12' style={{fontSize: '11px', padding: '0 0 0 10px'}}><span style={{marginLeft: '15px'}}>{this.props.translate('KRW.stepFour.form.position_x')}</span></div>
                        <div className='col l2 s12' style={{fontSize: '11px', padding: '0 0 0 10px'}}><span style={{marginLeft: '15px'}}>{this.props.translate('KRW.stepFour.form.position_y')}</span></div>
                        <div className='col l2 s12' style={{fontSize: '11px', padding: '0 0 0 10px'}}><span style={{marginLeft: '15px'}}>{this.props.translate('KRW.stepFour.form.size_x')}</span></div>
                        <div className='col l2 s12' style={{fontSize: '11px', padding: '0 0 0 10px'}}><span style={{marginLeft: '15px'}}>{this.props.translate('KRW.stepFour.form.size_y')}</span></div>
                    </div>

                    <RectangleLine
                        field={this.props.krw.AS1}
                        fieldSx={this.props.krw.AS1X}
                        fieldSy={this.props.krw.AS1Y}
                        fieldPx={this.props.krw.AS1PX}
                        fieldPy={this.props.krw.AS1PY}
                        fieldNumber={'1'}
                        />
                    { this.props.krw.AS1.CurrentValue === '1' ?
                        <RectangleLine
                            field={this.props.krw.AS2}
                            fieldSx={this.props.krw.AS2X}
                            fieldSy={this.props.krw.AS2Y}
                            fieldPx={this.props.krw.AS2PX}
                            fieldPy={this.props.krw.AS2PY}
                            fieldNumber={'2'}
                        />: ""}
                    { this.props.krw.AS2.CurrentValue === '1' ?
                        <RectangleLine
                            field={this.props.krw.AS3}
                            fieldSx={this.props.krw.AS3X}
                            fieldSy={this.props.krw.AS3Y}
                            fieldPx={this.props.krw.AS3PX}
                            fieldPy={this.props.krw.AS3PY}
                            fieldNumber={'3'}
                        />: ""}
                    { this.props.krw.AS3.CurrentValue === '1' ?
                        <RectangleLine
                            field={this.props.krw.AS4}
                            fieldSx={this.props.krw.AS4X}
                            fieldSy={this.props.krw.AS4Y}
                            fieldPx={this.props.krw.AS4PX}
                            fieldPy={this.props.krw.AS4PY}
                            fieldNumber={'4'}
                        />: ""}
                    { this.props.krw.AS4.CurrentValue === '1' ?
                        <RectangleLine
                            field={this.props.krw.AS5}
                            fieldSx={this.props.krw.AS5X}
                            fieldSy={this.props.krw.AS5Y}
                            fieldPx={this.props.krw.AS5PX}
                            fieldPy={this.props.krw.AS5PY}
                            fieldNumber={'5'}
                        />: ""}
                    <div className='row'>
                        <ImageContainer
                            image={this.props.image.Image}
                            name='krw'
                            divClass='col s12'
                            height='100%' />
                    </div>
                </div>
            </div>
        )
    }

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
Step4.propTypes = {
    stepControl: PropTypes.func.isRequired,
    krw:     PropTypes.object.isRequired,
};

function mapStateToProps({krw, locale, image}) {
    return {
        krw,
        translate: getTranslate(locale),
        image,
    }
}

export default connect(mapStateToProps, actions)(Step4);



// WEBPACK FOOTER //
// ./src/components/krw-steps/Step4.js